// extracted by mini-css-extract-plugin
module.exports =  {"loading":"loading--zjCNoRqE4Bsjr5oQxdSgRw=="};